var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M666.286 1242.8c-88.168-79.79-143.65-195.06-143.65-323.033V435.679C522.636 195.475 718.111 0 958.315 0c176.955 0 329.645 106.09 397.775 257.997L1536.8 0l92.38 64.669L331.381 1917.48 239 1852.81l305.289-435.84C412.414 1301.53 329 1132.02 329 943.408V709.98h96.818v233.428c0 155.812 67.32 296.242 174.393 393.722l66.075-94.33Zm129.034 207.58-57.716 82.4c54.294 20.4 112.129 33.5 172.304 38.1v252.3H667.861V1920h580.909v-96.82h-242.044v-252.3c324.464-24.8 580.904-296.76 580.904-627.472V709.98h-96.82v233.428c0 293.552-238.94 532.492-532.495 532.492-56.824 0-111.601-8.95-162.995-25.52Zm598.67-854.695L868.36 1346.11c29.036 6.12 59.127 9.34 89.955 9.34 240.205 0 435.675-195.48 435.675-435.683V595.685Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicOff);
export default __webpack_public_path__ + "static/media/icon-mic-off.f30896991698c8dafa830a2b5eaf375c.svg";
export { ForwardRef as ReactComponent };